import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-districtwise-vacant-property',
  templateUrl: './districtwise-vacant-property.component.html',
  styleUrls: ['./districtwise-vacant-property.component.css']
})
export class DistrictwiseVacantPropertyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/districtwise-vacant-property/districtwise-vacant-property.component.ts